module.exports = __webpack_public_path__ + "static/media/groupAbout.757ed6fe.png";